import React from "react";
import { Label } from "semantic-ui-react";
import searchHOC from "_forms/searchHOC";
import SuggestionItem from "_views/suggestionItem";
import { escapeRE } from "_utils";

const formatSelection = (reseller) => (
  <Label
    style={{ display: "inline-block" }}
    key={`reseller_sel_${reseller._id}`}
  >
    <div>{reseller.name}</div>
    <div>{reseller.contact_name}</div>
    <div>{reseller.contact_email}</div>
    <div><small>{reseller._id}</small></div>
  </Label>
);

const formatSuggestion = (reseller, term) => {
  const termRegex = {
    regex: new RegExp(escapeRE(term), "i"),
    term,
  };

  return (
    <div key={`reseller_sugg_${reseller._id}`}>
      <SuggestionItem label="Name" text={reseller.name} tReg={termRegex} always />
      <SuggestionItem label="Contact Name" text={reseller.contact_name} tReg={termRegex} always />
      <SuggestionItem label="Contact Email" text={reseller.contact_email} tReg={termRegex} always />
      <SuggestionItem label="ID" text={reseller._id} tReg={termRegex} always />
    </div>
  );
};

export const { SingularSearch } = searchHOC({
  icon: "user",
  placeholder: "Type to search Resellers...",
  idName: "resellerId",
  baseSearchUrl: "resellers",
  formatSelection,
  formatSuggestion,
});



// WEBPACK FOOTER //
// ./webAdmin/forms/resellerSearch.js